import Dropdown from 'primevue/dropdown'
import { ConnectedOverlayScrollHandler, DomHandler } from 'primevue/utils'

// Keeps a dropdown open on a phone while the page scrolls. Imported once, by main.js, before the app
// mounts, so it reaches every Dropdown in the app, whichever file imports it.
//
// PrimeVue 3 closes an open dropdown whenever anything around it scrolls. On a phone, tapping the
// list's filter opens the keyboard, and the browser scrolls the page to keep the filter in view, so
// the list closed before the agent could type, as on the coffee screens' "Select farmer". PrimeVue
// already leaves the list open when a phone's keyboard resizes the window. On a touch device the list
// now also stays open when the page scrolls, and moves with its field. On a desktop a scroll still
// closes it, as before.
const closeOnScroll = Dropdown.methods.bindScrollListener

if (!closeOnScroll.phoneSafe) {
  Dropdown.methods.bindScrollListener = function bindScrollListener() {
    if (!DomHandler.isTouchDevice()) return closeOnScroll.call(this)

    if (!this.scrollHandler) {
      this.scrollHandler = new ConnectedOverlayScrollHandler(this.$refs.container, () => {
        if (this.overlayVisible && this.overlay) this.alignOverlay()
      })
    }

    this.scrollHandler.bindScrollListener()
  }
  Dropdown.methods.bindScrollListener.phoneSafe = true
}
